module.exports = __webpack_public_path__ + "img/logo-coinbase.a64fd099.svg";